import { METADATA_AVATAR_TYPES } from '@/utils/CONST';
import { useGetList } from 'react-admin';
import { nth } from 'lodash';
import { MetadataAvatarType } from '@/utils/types';

interface Params {
    filters?: any;
    enabled?: boolean;
}

const useGetMetadataAvatarTypes = ({ filters = {}, enabled = true }: Params) => {
    const { data, isLoading, refetch }: any = useGetList(
        METADATA_AVATAR_TYPES,
        {
            filter: {
                ...filters,
            },
        },
        { enabled },
    );

    const metadataAvatarTypes = data as MetadataAvatarType[] | undefined;
    const firstMetadataAvatarType = nth(metadataAvatarTypes ?? [], 0);

    return {
        metadataAvatarTypes,
        firstMetadataAvatarType,
        firstMetadataAvatarTypeId: firstMetadataAvatarType?.id,
        isLoading,
        refetch,
    };
};

export default useGetMetadataAvatarTypes;
